<template>
  <!-- 人事查看 -->
  <div class="page-approve-view">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form  @keyup.enter.native="getTableList"   :model="form" class="com-search-box" ref="form" label-width="70px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="关键字 :" prop="key">
              <el-input v-model="form.key" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="部门 :" prop="department">
              <el-select clearable v-model="form.department" placeholder="请选择">
                <el-option v-for="item in departList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="时间 :">
              <el-date-picker
                v-model="form.year"
                type="year"
                value-format="yyyy"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>


          <!-- <el-col :span="10">
            <el-form-item label="人员类型 :" prop="employeeType">
              <el-select clearable v-model="form.employeeType" placeholder="请选择">
                <el-option v-for="item in personTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
      </el-form>

      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList('form')">重置</el-button>
      </div>

    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <!-- <div class="button">
        <el-row type="flex">
          <el-button style="margin-right: 20px" class="el-primary-border">
            导出
          </el-button>
        </el-row>
      </div> -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column prop="userName" label="姓名" min-width="8%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="department" label="部门" min-width="8%"></el-table-column>
          <!-- <el-table-column prop="employeeType" label="人员类型" min-width="7%"></el-table-column> -->
          <el-table-column prop="jjrJB" label="节假日加班" min-width="7%">
            <template slot-scope="scope">
              <span class="m-btn" @click="showDetail(scope.row, '2', '1')">{{ scope.row.jjrJB}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="qtJB" label="其他加班" min-width="7%">
            <template slot-scope="scope">
              <span class="m-btn" @click="showDetail(scope.row, '2', '2')">{{ scope.row.qtJB}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="ljJB" label="累计加班" min-width="7%">
            <template slot-scope="scope">
              <span class="m-btn" @click="showDetail(scope.row, '2')">{{ scope.row.ljJB}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="kyCX" label="可使用" min-width="6%"></el-table-column>
          <el-table-column prop="sjCX" label="将过期" min-width="6%"></el-table-column>
          <el-table-column prop="ljCX" label="已串休" min-width="6%">
            <template slot-scope="scope">
              <span class="m-btn" @click="showDetail(scope.row, '3')">{{ scope.row.ljCX}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="sjTS" label="事假天数" min-width="7%">
            <template slot-scope="scope">
              <span class="m-btn" @click="showDetail(scope.row, '1', '1')">{{ scope.row.sjTS}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="bjTS" label="病假天数" min-width="7%">
            <template slot-scope="scope">
              <span class="m-btn" @click="showDetail(scope.row, '1', '2')">{{ scope.row.bjTS}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="ljTS" label="累计请假天数" min-width="7%">
            <template slot-scope="scope">
              <span class="m-btn" @click="showDetail(scope.row, '1')">{{ scope.row.ljTS}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="syNJ" label="剩余年假天数" min-width="7%"></el-table-column>
          <!-- <el-table-column prop="sjNJ" label="实际可用年假" min-width="7%"></el-table-column> -->
          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="handleApprovePass(scope.row, '1')" v-if="scope.row.canApprove">通过</a>
              <a class="m-btn m-danger mr-10" @click="handleApprovePass(scope.row, '2')" v-if="scope.row.canApprove">驳回</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import dialogTimesList from './dialog-times-list.vue'
// import axios from 'axios'
export default {
  components: {
    dialogTimesList
  },
  data() {
    return {
      form: {
        key: '',
        department: '',
        year: '',
        employeeType: ''
      },
      listLoading: true,
      tableData: [],
      personTypeList: [],
      departList: [],
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0
    }
  },

  methods: {
    initData() {
      this.$http
        .get('/attendanceStat/list', {
          ...this.listQuery,
          ...this.form
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            this.tableData = res.result
            this.total = res.page.allRow

            console.log(this.tableData)
          } else {
            this.$message.error(res.message)
          }
        }).catch(err => {
          this.listLoading = false
        })

    },

    handleApprovePass(item, type) {
      let str = type === '1' ? '通过' : '驳回'
      this.$common.confirm(
        {
          title: `是否确认${str}？`,
          className: 'cus-confirm-375'
        }, () => {
          console.log(3445)
          this.sendApprovalPass(item, type)
        }
      )
    },

    // 审批通过 // 驳回
    sendApprovalPass(item, type) {
      this.$http
        .get('/attendanceStat/apply', {
          userId: this.$store.state.user.userid,
          type: type === '1' ? '1' : '2',  // 0 申请延期 1 审核同意 2 审核驳回
          year: item.year
        })
        .then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.initData()
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(() => {
        })
    },

    showDetail(row, type, businessType) {
      this.$router.push({
        path: '/approve/view-person-detail',
        query:{pageType:type, businessType: businessType,obj: encodeURIComponent(JSON.stringify(row))}
      })
      // this.$refs.dialogTimesList.init({
      //   pageType: type, // 1 请假 2 加班 3 串休
      //   ...row
      // }, businessType)
    },

    // 获取下拉状态多选择值
    getDropdownValue() {
      this.$http.get('/job/employeeDict', {
      }).then(res => {
        if (res.success) {
          let data = res.result
          let firstArr = [{ id: null, name: '全部' }]
          this.personTypeList = firstArr.concat(data.employeeType)
          this.departList = firstArr.concat(data.department2)
        } else {
          this.$message.error(res.message)
        }
      })
    },

    restList(formName) {
      this.$refs[formName].resetFields();
      this.listQuery.currentPage = 1
      this.initData()
    },

    getTableList(){
      this.listQuery.currentPage = 1
      this.initData()
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initData()
    }
  },

  mounted() {
    this.getDropdownValue()
    this.initData()
  }
}
</script>

<style lang="scss" scoped>

</style>